import WithGASetup from '../../components/WithGASetup';
import ResetPasswordPage from './ResetPasswordPage.js';

export default WithGASetup(ResetPasswordPage);
